var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "alphabetical-list__grid js-sticky" },
    [
      _vm.searchConfig
        ? _c(
            "nav",
            {
              staticClass:
                "alphabetical-list__nav alphabetical-list__nav--virtual",
              attrs: { "aria-label": _vm.search.ariaLabel },
            },
            [
              _c(
                "div",
                {
                  ref: "navstretchbar",
                  staticClass: "alphabetical-list__stretch-bar",
                },
                [
                  _c(
                    "div",
                    { staticClass: "alphabetical-list__nav__wrapper" },
                    [
                      _c(
                        "ol",
                        { staticClass: "alphabetical-list__nav__list" },
                        [
                          _vm._l(_vm.navItems, function (navItem, index) {
                            return [
                              _c(
                                "li",
                                {
                                  key: index,
                                  staticClass: "alphabetical-list__nav__item",
                                  class: [
                                    navItem.hasResults === true
                                      ? "has-results"
                                      : "",
                                  ],
                                },
                                [
                                  navItem.hasResults
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "alphabetical-list__nav__link",
                                          attrs: { href: "#" + navItem.label },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.setLetterFocus(
                                                navItem.label
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "alphabetical-list__nav__link__text",
                                            },
                                            [_vm._v(_vm._s(navItem.label))]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !navItem.hasResults
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "alphabetical-list__nav__link",
                                          attrs: { disabled: "" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "alphabetical-list__nav__link__text",
                                            },
                                            [_vm._v(_vm._s(navItem.label))]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "alphabetical-list__nav__highlight",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "alphabetical-list__nav__highlight__wrapper",
                                        },
                                        [_vm._v(_vm._s(navItem.label))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.searchConfig
        ? _c(
            "div",
            { ref: "search", staticClass: "alphabetical-list__search" },
            [
              _c(
                "div",
                {
                  ref: "searchstretchbar",
                  staticClass: "alphabetical-list__stretch-bar",
                },
                [
                  _c(
                    "div",
                    { staticClass: "alphabetical-list__search__wrapper" },
                    [
                      _c("div", { staticClass: "textfield" }, [
                        _c("label", [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(_vm._s(_vm.searchConfig.label)),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.search,
                                expression: "search",
                              },
                            ],
                            staticClass: "textfield__input",
                            attrs: {
                              placeholder: _vm.searchConfig.label,
                              type: "search",
                            },
                            domProps: { value: _vm.search },
                            on: {
                              focus: _vm.handleSearchFocus,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.search = $event.target.value
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 24 24",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M23.3 20.7L17.6 15c1.2-1.8 1.8-4 1.6-6.2-.2-2.5-1.5-4.8-3.4-6.4C14 1 11.9.2 9.7.2 7.2.2 4.8 1.2 3 3 1.2 4.8.2 7.2.2 9.7s1 4.9 2.8 6.7c1.8 1.8 4.2 2.8 6.7 2.8 1.9 0 3.7-.6 5.2-1.6l5.6 5.6c.3.4.8.6 1.3.6h.1c.5 0 .9-.2 1.2-.5.4-.3.6-.8.6-1.3.1-.5-.1-1-.4-1.3zM9.7 3.9c3.2 0 5.8 2.6 5.8 5.8 0 3.2-2.6 5.8-5.8 5.8-3.2 0-5.8-2.6-5.8-5.8 0-1.5.6-3 1.7-4.1 1.1-1.1 2.5-1.7 4.1-1.7z",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { ref: "results", staticClass: "alphabetical-list__results" },
        [
          _vm.orderedItems.length > 0
            ? _c("virtual-list", {
                ref: "vsl",
                attrs: {
                  "data-key": "id",
                  "data-sources": _vm.orderedItems,
                  "data-component": _vm.itemComponent,
                  "estimate-size": 54,
                  keeps: 40,
                  "page-mode": true,
                  "extra-props": {
                    searchTerm: _vm.search,
                  },
                  "wrap-class": "alphabetical-list__results__list",
                },
              })
            : _c("div", { staticClass: "alphabetical-list__results__none" }, [
                _vm._v("\n      " + _vm._s(_vm.noResultsMessage) + "\n    "),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("aside"),
      _vm._v(" "),
      [
        _vm.popup
          ? _c(
              "div",
              {
                staticClass: "popup",
                attrs: { role: "dialog", transition: "modal" },
                on: {
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape",
                      ])
                    )
                      return null
                    return _vm.closePopup.apply(null, arguments)
                  },
                },
              },
              [
                _c("span", {
                  staticClass: "popup__overlay",
                  on: { click: _vm.closePopup },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "popup__wrapper theme--white" }, [
                  _c("div", { staticClass: "popup__content" }, [
                    _c("strong", { staticClass: "popup__title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.popup.title) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.popup.desc
                      ? _c("div", { staticClass: "popup__desc" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.popup.desc) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "alphabetical-list__options" },
                    [
                      _vm._l(_vm.popup.options, function (option, index) {
                        return [
                          _c(
                            "a",
                            {
                              key: index,
                              ref: "popupOptions",
                              refInFor: true,
                              staticClass: "btn btn--black",
                              attrs: { href: option.url },
                              on: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "tab",
                                      9,
                                      $event.key,
                                      "Tab"
                                    )
                                  )
                                    return null
                                  if (!$event.shiftKey) return null
                                  return _vm.focusPopupClose.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "btn__content" }, [
                                _c("span", { staticClass: "btn__text" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(option.name) +
                                      "\n                "
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      ref: "popupClose",
                      staticClass: "popup__close",
                      on: {
                        click: _vm.closePopup,
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                          )
                            return null
                          if (
                            $event.ctrlKey ||
                            $event.shiftKey ||
                            $event.altKey ||
                            $event.metaKey
                          )
                            return null
                          return _vm.focusFirstPopupOption.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "sr-only" }, [_vm._v("Close")]),
                      _vm._v(" "),
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 16 15.983",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M1.772 0A1.774 1.774 0 00.537 3.046L5.491 8 .537 12.955a1.774 1.774 0 102.509 2.509L8 10.509l4.954 4.954a1.774 1.774 0 102.509-2.509L10.508 8l4.954-4.954A1.774 1.774 0 1012.954.538L7.999 5.492 3.045.537A1.774 1.774 0 001.772 0z",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }